module.exports = __webpack_public_path__ + "img/Polygon5.d1cf4c36.svg";